import { render } from "./features.vue?vue&type=template&id=da32ed3a&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"

import "./features.vue?vue&type=style&index=0&id=da32ed3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da32ed3a"]])

export default __exports__